import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import styled from 'styled-components';
import { Site } from '@debbie/common/dist';
import { getDebtorsOnCustomer, } from '@debbie/common/dist/customers';
import THEME from '../../theme';
import PlusCircle from '../Icons/PlusCircle';
import DeleteModal from './DeleteModal';
import ErrorModal from './ErrorModal';
import MoveToOpenModal from './MoveToOpenModal';
import NewRegistrationModal from './NewRegistrationModal';
import RKIRegistration from './RKIRegistration';
import StatusModal from './StatusModal';
import { useCreditor } from '@debbie/cortex/dist/creditors';
import { h } from '@debbie/cortex/dist';
const RKIReporting = (props) => {
    const singleCase = props.case;
    const creditorLoadable = useCreditor(singleCase === null || singleCase === void 0 ? void 0 : singleCase.creditorId);
    const creditor = h.hasData(creditorLoadable) ? creditorLoadable.data : null;
    const lang = useSelector((s) => s.lang);
    const site = useSelector((s) => s.site);
    const [modalOpen, setModalOpen] = useState(false);
    const [deleteModalOpen, setDeleteModalOpen] = useState(false);
    const [statusModalOpen, setStatusModalOpen] = useState(false);
    const [debtorUserId, setDebtorUserId] = useState(null);
    const [rkiReferenceId, setRkiReferenceId] = useState(null);
    const [errorModalOpen, setErrorModalOpen] = useState(false);
    const [moveToOpenModalOpen, setMoveToOpenModalOpen] = useState(false);
    const [rkiStatus, setRkiStatus] = useState(null);
    const debtors = getDebtorsOnCustomer(props.customer);
    const registrations = debtors.reduce((acc, d) => d.details.rkiReports
        ? acc.concat(d.details.rkiReports.filter((r) => {
            var _a;
            return r.referenceId === d.userId &&
                (((_a = r.journalId) === null || _a === void 0 ? void 0 : _a.split('-')[0]) === singleCase.id.toString() ||
                    r.caseId === singleCase.caseId);
        }))
        : acc, []);
    const debtorUser = debtors.find((d) => d.userId === debtorUserId);
    useEffect(() => {
        if (!debtorUserId) {
            const debtorContact = debtors.find((d) => d.contact) || debtors[0];
            if (debtorContact) {
                setDebtorUserId(debtorContact.userId);
            }
        }
    }, [props.case]);
    const toggleModal = () => setModalOpen(!modalOpen);
    const toggleDeleteModal = () => setDeleteModalOpen(!deleteModalOpen);
    const toggleMoveToOpenModal = () => setMoveToOpenModalOpen(!moveToOpenModalOpen);
    const toggleErrorOpenModal = () => setErrorModalOpen(!errorModalOpen);
    const toggleStatusModal = () => {
        setStatusModalOpen(!statusModalOpen);
        setRkiStatus(null);
    };
    return (React.createElement("div", null,
        site === Site.Caseworker && (React.createElement(RKIReportingStyled, { onClick: creditor && creditor.experianClientId
                ? toggleModal
                : () => alert('Kreditor er ikke registreret som kunde af inddriver hos Experian. Kontakt Experian og indhent kreditors Experian-klientnummer.'), className: "ui-test-4da65h35", style: {
                cursor: creditor && creditor.experianClientId ? 'pointer' : 'initial',
            } },
            React.createElement("h3", { className: "rki-title" },
                lang.RKI.registration,
                React.createElement("small", null)),
            React.createElement("p", { className: "rki-interval" },
                React.createElement(PlusCircle, { style: {
                        margin: '.2em 0 -.2em',
                    } }),
                ' ',
                lang.RKI.createNewRegistration))),
        deleteModalOpen && (React.createElement(DeleteModal, { case: props.case, toggleDeleteModal: toggleDeleteModal, userId: debtorUser && debtorUser.userId, rkiReferenceId: rkiReferenceId, customer: props.customer })),
        statusModalOpen && (React.createElement(StatusModal, { toggleStatusModal: toggleStatusModal, rkiStatus: rkiStatus })),
        moveToOpenModalOpen && (React.createElement(MoveToOpenModal, { caseVouchers: props.caseVouchers, case: props.case, toggleMoveToOpenModal: toggleMoveToOpenModal, userId: debtorUser && debtorUser.userId, rkiReferenceId: rkiReferenceId, customer: props.customer })),
        errorModalOpen && (React.createElement(ErrorModal, { caseId: props.case.caseId, toggleErrorOpenModal: toggleErrorOpenModal, userId: debtorUser && debtorUser.userId, rkiReferenceId: rkiReferenceId, customer: props.customer })),
        modalOpen && (React.createElement(NewRegistrationModal, { caseVouchers: props.caseVouchers, case: props.case, debtorUser: debtorUser, userId: debtorUserId, setUserId: setDebtorUserId, toggleModal: toggleModal, customer: props.customer })),
        registrations &&
            !!registrations.length &&
            registrations.map((rkiReport) => (React.createElement(RKIRegistration, { key: rkiReport.rkiReferenceId, case: props.case, rkiReport: rkiReport, toggleDeleteModal: toggleDeleteModal, toggleMoveToOpenModal: toggleMoveToOpenModal, setErrorModalOpen: setErrorModalOpen, setStatusModalOpen: setStatusModalOpen, setRkiStatus: setRkiStatus, setDebtorId: setDebtorUserId, setRkiReferenceId: setRkiReferenceId })))));
};
export default RKIReporting;
const RKIReportingStyled = styled.div `
  border-radius: 4px;
  background-color: #e6e6e6;
  padding: 5px;
  margin-bottom: 10px;

  .rki-title {
    font-size: 0.7em;

    small {
      font-size: 0.9em;
      float: right;
      font-weight: bold;
    }
  }

  .rki-interval {
    font-size: 0.6em;
    margin: 0.7em 0 0.4em 0;
  }

  .pp-delete {
    float: right;
    width: 14px;
    height: 14px;
    background-color: lightgrey;
    border-radius: 10px;
    padding: 2px 0 2px 1px;
    text-align: center;
    color: ${THEME.COLOR_SECONDARY};
    cursor: pointer;
  }
`;
//# sourceMappingURL=RKIReporting.js.map